<template>
  <div v-if="items.length" class="key-value-viewer">
    <el-row v-for="(item, index) in items" :key="index" class="row">
      <el-col :span="12" class="col">
        <el-input :value="item.key" disabled />
      </el-col>
      <el-col :span="12" class="col">
        <el-input :value="item.value" disabled />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'KeyValueViewer',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.key-value-viewer {
  padding: 0;
}

.row {
  margin: 6px 0 !important;
}

.col {
  padding-right: 8px !important;
}

.col:last-child {
  padding-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/KeyValueViewer.vue